import React from 'react';

import FormattedMessage from '../FormattedMessage';

export default function FormattedHTMLMessage(props) {
  return <FormattedMessage {...props} isHTML />;
}
